import { render, staticRenderFns } from "./VoltageGuage.vue?vue&type=template&id=64160d33&"
import script from "./VoltageGuage.vue?vue&type=script&lang=js&"
export * from "./VoltageGuage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports